import { render, staticRenderFns } from "./getBindCode.vue?vue&type=template&id=c0003914&scoped=true"
import script from "./getBindCode.vue?vue&type=script&lang=js"
export * from "./getBindCode.vue?vue&type=script&lang=js"
import style0 from "./getBindCode.vue?vue&type=style&index=0&id=c0003914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0003914",
  null
  
)

export default component.exports